
import { useAuthStore } from '~/store/auth'
import { useEventStore } from '~/store/event'
import { useWishStore } from '~/store/wish'
import { ref as refState} from 'vue'
import dayjs from 'dayjs'
import _debounce from 'lodash/debounce.js'
import _size from 'lodash/size.js'
import _find from 'lodash/find.js'
import _includes from 'lodash/includes.js'

const eventTrackingToday = () => {
  const route = useRoute()
  const eventStore = useEventStore()
  const authStore = useAuthStore()
  const wishStore = useWishStore()

  const eventData = computed(() => eventStore.eventData)
  const wishData = computed(() => wishStore.wishData)
  const wishTrackingData = computed(() => eventStore.wishTrackingData)
  const wishId = computed(() => wishStore.wishDocId)

  

  watch(() => route.path, async() => {

    if(!eventData.value) {
      return console.log('ไม่มีข้อมูลงาน หรือ wishId')
    }


    const currentPage = getCurrentPage()    
    console.log(currentPage?.code)

    
    // ไม่เคยมีประวัติ
    if(!wishTrackingData.value?.page) {
      await eventStore.updateEventUserTrackingPage(currentPage, wishData.value)
      localStorage.setItem('wish_tracking', wishId.value)
      console.log('update ครั้งแรก')
      return
    }


    if(currentPage?.code === 500) {
      await eventStore.updateEventUserTrackingPage(currentPage, {})
      localStorage.removeItem('wish_tracking')
      console.log('update thank you')
      return
    }

    // หน้าล่าสุดไกลกว่าประวัติที่เคยเขียน
    if(currentPage?.code > wishTrackingData.value?.code) {
      await eventStore.updateEventUserTrackingPage(currentPage, wishData.value)
      console.log('update หน้าล่าสุด')
      return
    }
  })


  function getCurrentPage():any {
    const codes = [
      {
        code: 100,
        path: '/event/',
        page: 'welcome'
      },
      {
        code: 200,
        path: '/selectUploadAndWish',
        page: 'selectUploadAndWish'
      },
      {
        code: 300,
        path: '/selectTemplate',
        page: 'selectTemplate'
      },
      {
        code: 400,
        path: '/editor',
        page: 'editor'
      },
      {
        code: 500,
        path: '/thankyou',
        page: 'thankyou'
      },
    ]

    if(_includes(route.path, '/event/')) {
      return codes[0]
    }

    const data = _find(codes, c => _includes(c.path, route.path))
    return data
  }
}

export default eventTrackingToday